const navGroups: { title: string; links: string[] }[] = [];

const handleScroll = (label: string) => {
  const map: Record<string, string> = {
    Home: "home", Framework: "framework", Learn: "learn", About: "about",
    Impact: "impact", Research: "research", Founder: "founder", Contact: "contact",
  };
  const id = map[label];
  if (id) {
    const el = document.getElementById(id);
    if (el) { const top = el.getBoundingClientRect().top + window.scrollY - 80; window.scrollTo({ top, behavior: "smooth" }); }
  }
};

export default function Footer() {
  return (
    <footer className="bg-[#1e3a5f] border-t border-[#1d4ed8]/30">
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-16">
        <div className="flex flex-col mb-12">
          <div className="md:col-span-1">
            <img
              src="https://static.readdy.ai/image/a3e8b0182dc4ba81eda0b98b43a24071/78db0cf24975dd645ae6a4e071d94155.png"
              alt="CashLearn Logo"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-white/60 text-xs leading-relaxed font-['Inter'] mb-5">
              Transforming financial education through research, community, and purposeful design.
            </p>
            <div className="flex gap-3">
              <a href="https://linkedin.com/company/cash-learn" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 border border-white/20 text-white/60 hover:text-white hover:border-white/50 transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-sm" />
              </a>
              <a href="https://www.instagram.com/cash.learn?igsh=MXFpbWozc2d0cHlieg%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 border border-white/20 text-white/60 hover:text-white hover:border-white/50 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm" />
              </a>
            </div>
          </div>

          {navGroups.map((group, i) => (
            <div key={i}>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4 font-['Inter']">
                <a href={`#${group.title.toLowerCase()}`}>{group.title}</a>
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link, j) => (
                  <li key={j}>
                    {link === "Learn" ? (
                      <a href="https://learn.cashlearn.org" target="_blank" rel="noopener noreferrer"
                        className="text-xs text-white/60 hover:text-white transition-colors cursor-pointer font-['Inter']">
                        {link}
                      </a>
                    ) : (
                      <a href={`#${link.toLowerCase()}`} onClick={(e) => { e.preventDefault(); handleScroll(link); }}
                        className="text-xs text-white/60 hover:text-white transition-colors cursor-pointer font-['Inter']">
                        {link}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40 font-['Inter']">&copy; 2026 CashLearn. All rights reserved.</p>

        </div>
      </div>
    </footer>
  );
}
